export default "\r\n<header>\r\n  <nav>\r\n    <div class=\"logo\" (click)=\"navigateHapvidaHome()\"></div>\r\n  </nav>\r\n</header>\r\n";